<template>
  <div class="box">
    <v-row class="">
      <v-col class="noYPadding">
        <VSelect
          v-model="data.cycleType.type"
          :label="$t('treatmentProgram.step2.cycleType')"
          :items="displayedUnits('cycleTypeUnit')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="cycleType"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- Cycle Type -->
    <p class="xPadding titleModal mb-0">
      {{ $t(`treatmentProgram.step2.injectionTime`) }}
    </p>
    <v-row>
      <v-col
        class="noYPadding"
        cols="12"
      >
        <VDayPicker
          v-model="data.cycleType.schedules"
          class="date-picker"
          :label="$t('treatmentProgram.step2.start')"
          :locale="datePickerLocales[$store.getters.lang]"
          @input="updateData"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <VTextField
          v-model="data.cycleType.otherInfo"
          :label="$t('treatmentProgram.step2.otherInfo')"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- End Cycle Type -->
    <p class="xPadding titleModal mb-0">
      {{ $t(`treatmentProgram.step2.prebleed`) }}
    </p>
    <v-row class="">
      <v-col class="noYPadding">
        <VSelect
          v-model="data.prebleed.isActive"
          :label="$t('treatmentProgram.step2.prebleed')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="prebleed"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- Prebleed to yes -->
    <v-row v-if="isTrue(data.prebleed.isActive)">
      <v-col class="noYPadding">
        <VTextField
          v-model="data.prebleed.duration.value"
          :label="$t('treatmentProgram.step2.duration')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col class="noYPadding">
        <VSelect
          v-model="data.prebleed.duration.unit"
          :label="$t('treatmentProgram.step2.unit')"
          :items="displayedUnits('prebleedUnit')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="prebleedUnit"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- End Prebleed to yes -->
    <p class="xPadding titleModal mb-0">
      {{ $t(`treatmentProgram.step2.blowdownLockOut`) }}
    </p>
    <v-row class="">
      <v-col class="noYPadding">
        <VSelect
          v-model="data.blowdownLockOut.isActive"
          :label="$t('treatmentProgram.step2.blowdownLockOut')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="blowdownLockOut"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- blowdownLockOut to yes -->
    <v-row v-if="isTrue(data.blowdownLockOut.isActive)">
      <v-col class="noYPadding">
        <VTextField
          v-model="data.blowdownLockOut.duration.value"
          :label="$t('treatmentProgram.step2.duration')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col class="noYPadding">
        <VSelect
          v-model="data.blowdownLockOut.duration.unit"
          :label="$t('treatmentProgram.step2.unit')"
          :items="displayedUnits('blowdownLockOutUnit')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="blowdownLockOutUnit"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- End blowdownLockOut to yes -->
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VDayPicker from '@/components/shared/widgets/forms/VuetifyInputs/VDayPicker';
import _datePickerLocales from '@/locales/date-picker-locales';


export default {
    name: 'Schedule',
    components: {
        VTextField,
        VDayPicker,
    },
    props: {
        model: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        ...mapGetters([
            'treatmentProgramUnits',
        ]),
        datePickerLocales() {
            return _datePickerLocales;
        },
    },
    watch: {
        model: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.model) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { schedule: this.data });
        },
        displayedUnits(type) {
            return this.treatmentProgramUnits && this.treatmentProgramUnits[type]
                ? this.treatmentProgramUnits[type] : [];
        },
        isTrue(property) {
            return property === 0;
        },
    },
};
</script>
<style lang="scss" scoped>
.noYPadding {
    padding-bottom: 0px;
    padding-top: 0px;
}
.box {
    width: 100%;
    padding: 0 1rem;
}
.date-picker {
  width: 100%;
}
</style>
